// 定义内容
export default {
	label: {
		one1: '用户名登录',
		two2: '手机号登录',
	},
	link: {
		one3: '第三方登录',
		two4: '友情链接',
	},
	account: {
		accountPlaceholder1: '用户名 admin 或不输均为 common',
		accountPlaceholder2: '密码：123456',
		accountPlaceholder3: '请输入验证码',
		accountBtnText: '登 录',
	},
	mobile: {
		placeholder1: '请输入手机号',
		placeholder2: '请输入验证码',
		codeText: '获取验证码',
		invitationCodeText: '邀请码',
		btnText: '登 录',
		msgText: '* 温馨提示：建议使用谷歌、Microsoft Edge，版本 79.0.1072.62 及以上浏览器，360浏览器请使用极速模式',
	},
	scan: {
		text: '打开手机扫一扫，快速登录/注册',
	},
	signInText: '欢迎回来！',
	router: {
		home: '首页',
		chat: '智能问答',
		file: '知识库',
		uie: 'UIE',
		personage: '人物库',
		system: '系统设置',
		systemMenu: '通用布局',
		systemRole: '数据录入',
		systemUser: '数据展示',
		systemDept: '部门管理',
		systemDic: '字典管理',
		layoutLinkView: '外链',
		layoutIframeViewOne: '内嵌 iframe1',
		layoutIframeViewTwo: '内嵌 iframe2',
	},
	staticRoutes: {
		signIn: '登录',
		notFound: '找不到此页面',
		noPower: '没有权限',
	},
	user: {
		title1: '语言切换',
		title3: '布局配置',
		title4: '消息',
		title5: '开全屏',
		title6: '关全屏',
		dropdown1: '首页',
		dropdown2: '个人中心',
		dropdown3: '404',
		dropdown4: '401',
		dropdown5: '退出登录',
		newTitle: '通知',
		newBtn: '全部已读',
		newGo: '前往通知中心',
		newDesc: '暂无通知',
		logOutTitle: '提示',
		logOutMessage: '此操作将退出登录，是否继续？',
		logOutConfirm: '确定',
		logOutCancel: '取消',
		logOutExit: '退出中',
		small: '小',
		default: '中',
		large: '大',
	},
	tagsView: {
		refresh: '刷新',
		close: '关闭',
		closeOther: '关闭其它',
		closeAll: '全部关闭',
		fullscreen: '当前页全屏',
		closeFullscreen: '关闭全屏',
	},
	notFound: {
		foundTitle: '地址输入错误，请重新输入地址~',
		foundMsg: '您可以先检查网址，然后重新输入或给我们反馈问题。',
		foundBtn: '返回首页',
	},
	noAccess: {
		accessTitle: '您未被授权，没有操作权限~',
		accessBtn: '重新授权',
	},
	layout: {
		themeColor: '主题颜色',
		configTitle: '布局配置',
		oneTitle: '全局主题',
		twoTopTitle: '顶栏设置',
		twoMenuTitle: '菜单设置',
		twoTopBar: '顶栏背景',
		twoTopBarColor: '顶栏默认字体颜色',
		twoMenuBar: '菜单背景',
		twoMenuBarColor: '菜单默认字体颜色',
		twoMenuBarActiveColor: '菜单高亮背景色',
		threeTitle: '界面设置',
		threeIsCollapse: '菜单水平折叠',
		threeIsUniqueOpened: '菜单手风琴',
		threeIsFixedHeader: '固定 Header',
		threeIsClassicSplitMenu: '经典布局分割菜单',
		fourTitle: '界面显示',
		fourIsShowLogo: '侧边栏 Logo',
		fourIsBreadcrumb: '开启 Breadcrumb',
		fourIsBreadcrumbIcon: '开启 Breadcrumb 图标',
		fourIsTagsview: '开启 Tagsview',
		fourIsTagsviewIcon: '开启 Tagsview 图标',
		fourIsCacheTagsView: '开启 TagsView 缓存',
		fourIsSortableTagsView: '开启 TagsView 拖拽',
		fourIsShareTagsView: '开启 TagsView 共用',
		fourIsFooter: '开启 Footer',
		fourIsGrayscale: '灰色模式',
		fourIsDark: '深色模式',
		fourIsWartermark: '开启水印',
		fourWartermarkText: '水印文案',
		fiveTitle: '其它设置',
		fiveTagsStyle: 'Tagsview 风格',
		fiveAnimation: '主页面切换动画',
		sixTitle: '布局切换',
		sixDefaults: '默认',
		sixClassic: '经典',
		sixTransverse: '横向',
		tipText: '点击下方按钮，复制布局配置去 `src/stores/themeConfig.ts` 中修改。',
		copyText: '一键复制配置',
		resetText: '一键恢复默认',
		copyTextSuccess: '复制成功！',
		copyTextError: '复制失败！',
	},
	stepForm: {
		form: {
			activityName: '活动名称',
			channelType: '渠道类型',
			promotionTime: '推广时间',
			promoteLink: '推广地址',
		},
		placeholder: {},
	},
	uie: {
		introTitleUIE: 'YAYI-UIE精准的',
		introTitleExtrac: '知识抽取',
		introTitleAI: 'AI助手',
		introTitleMain: '基于百万级中英双语料，结合有监督微调与人类意图对齐，在信息抽取领域表现突出，支持舆情、媒宣、金融、安全等领域复杂场景信息抽取。',
		enterkeyword: '输入关键词',
		enterDetail: '进入',
		extractInfor: '抽取信息',
		extractContent: '抽取内容',
		extractResults: '抽取结果',
		copyJSON: '复制JSON',
		extractionProgress: '正在抽取中',
		sendExtractedView: '左侧发送抽取内容后查看',
		record: '记录',
		historyRecord: '历史记录',
		confirmDeletSession: '确认删除此会话',
		confirm: '确认',
		cancel: '取消',
		submit: '提交',
		nohistory: '暂无历史记录',
		feedbackMeansLot: '您的反馈对我们意义重大，希望您填写您认为',
		moreDesAnswer: '您认为更理想的答案是什么？',
		abnormalNetwork: '当前网络异常，请检查网络',
		copySuccessful: '复制成功',
		likeSuccess: '点赞成功',
		tapSuccess: '点踩成功',
		hisNameNoEmpty: '历史记录名称不能为空'
	}
};
